import { useLoaderData } from '@remix-run/react'
import {
	type LoaderFunction,
	type LoaderFunctionArgs,
	json,
} from '@remix-run/node'
import ArtistsList from '#app/components/artistsList/artistsList.tsx'
import { getENSname } from '#app/utils/ens.server.ts'
import { asyncTruncateStringInMiddle } from '#app/utils/misc.tsx'
import { type artist, type socials, type wallet } from '#types/loreTypes.tsx'

export const loader: LoaderFunction = async ({
	request,
	params,
}: LoaderFunctionArgs) => {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			limit: 25,
			offset: 0,
			sortField: 'name',
			sortOrder: 'ASC',
			topCollectionsLimit: 3,
		}),
	}
	const artistIndexResponse = await fetch(
		`${import.meta.env.VITE_MARIADB_API_ENDPOINT}/api/v1/profiles`,
		options,
	)

	return json({ artists: artistIndex })
}

export default function artistList() {
	const { artists } = useLoaderData<{ artists: artist[] }>()

	return <ArtistsList artists={artists} />
}
